import { render } from "./EmailEditor.vue?vue&type=template&id=0f790466&scoped=true"
import script from "./EmailEditor.vue?vue&type=script&lang=js"
export * from "./EmailEditor.vue?vue&type=script&lang=js"

import "./EmailEditor.vue?vue&type=style&index=0&id=0f790466&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f790466"]])

export default __exports__